module.exports = __webpack_public_path__ + "img/st-vincent-and-the-grenadines.ec5ec5f7.png";